// extracted by mini-css-extract-plugin
export default {"WidgetContent":"GoogleMeetWidgetTeacher_WidgetContent__9Pidg","GoogleMeetText":"GoogleMeetWidgetTeacher_GoogleMeetText__PdhXV"};